/**
 * CLIENT SUPPLIED MODAL
 * 
 * Modal for when client is providing their own product
 */

import React, { useState } from 'react';

const ClientSuppliedModal = ({ fixture, onSave, onClose }) => {
  const [data, setData] = useState({
    product_name: '',
    allowance_amount: 0,
    notes: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(data);
  };

  if (!fixture) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>Client Supplying Product</h2>
        <p className="modal-subtitle">
          For: {fixture.fixture_label} in {fixture.area_label}
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Product Description</label>
              <input
                type="text"
                value={data.product_name}
                onChange={(e) => setData({ ...data, product_name: e.target.value })}
                placeholder="What product will the client provide?"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Labor Allowance ($)</label>
              <input
                type="number"
                value={data.allowance_amount}
                onChange={(e) => setData({ ...data, allowance_amount: parseFloat(e.target.value) || 0 })}
                placeholder="0"
                min="0"
                step="1"
              />
              <span className="help-text">
                Amount to include for installation labor
              </span>
            </div>
            
            <div className="form-group">
              <label>Notes</label>
              <textarea
                value={data.notes}
                onChange={(e) => setData({ ...data, notes: e.target.value })}
                placeholder="Any special requirements or details..."
              />
            </div>
          </div>
          
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClientSuppliedModal;
